import axios from "axios";
import { getStorageItem } from "../helpers/local-storage";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_BACKEND,
});

instance.interceptors.request.use(
  (config) => {
    const tokens = getStorageItem("KC_TOKEN");
    if (tokens) {
      const token = JSON.parse(tokens).token;
      config.headers.Authorization = `Bearer ${token}`;
    } else config.headers.Authorization = "";
    return config;
  },
  (error) => Promise.reject(error)
);

export default instance;
